import React from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import {useAppContext } from  "./../AppContext"
import DashboardTabs from "./DashboardTabs.js";
function AppHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser,isAuthenticated } = useAppContext();

  const isRootPath = location.pathname === "/";

  const handleLogout = () => {
    // setRole(null); // clear role
    // setIsAuthenticated(false); // mark as not authenticated
    // navigate("/");
    setUser(null);
    navigate("/app");
  };

  return (
    <nav className="navbar navbar-expand-lg">
        <div className="container">
          <a className="navbar-brand" href="/">
            Sadhana Kumar, MD
          </a>
          {
            !isRootPath && <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#menu"
            aria-controls="menu"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          }
          
          {
              !isRootPath && <div className="collapse navbar-collapse" id="menu">
            <ul className="navbar-nav ms-auto align-items-lg-center">
             
 {/* { isAuthenticated && 
              <li className="nav-item">
                <Link to="/doctor-dashboard" className="book-btn">
                  Dashboard
                </Link>
              </li>} */}

              { !isAuthenticated && 
              <li className="nav-item" >
                {/* <a className="nav-link" href="#home">
                  Home
                </a> */}
 <Link to="/app" className="nav-link">
                  Home
                </Link>

              </li>}
 { !isAuthenticated && 
              <li className="nav-item">
                <Link to="/about" className="nav-link">
                  About
                </Link>
                {/* <a className="nav-link" href="#about">
                  About
                </a> */}
              </li>}
 { !isAuthenticated && 
              <li className="nav-item">
                {/* <a className="nav-link" href="#services">
                  Services
                </a> */}
                 <Link to="/ourservices" className="nav-link">
                  Services
                </Link>
              </li>}
 { !isAuthenticated && 
              <li className="nav-item">
                {/* <a className="nav-link" href="#contact">
                  Contact
                </a> */}
                  <Link to="/contact" className="nav-link">
                    Contact
                  </Link>
              </li>}
               {/* { isAuthenticated && 
              <li className="nav-item">
                <Link to="/doctor-vedio" className="book-btn">
                  Vedio Invite
                </Link>
              </li>} */}

              { !isAuthenticated && <li className="ms-lg-4 mt-3 mt-lg-0">
                <Link to="/request-appointment" className="book-btn">
                  Book Appointment
                </Link>
              </li> }
              { !isAuthenticated && 
               <li className="ms-lg-4 mt-3 mt-lg-0">
                {/* <a href="/lander" className="book-btn" >
                  Login
                </a> */}
                <Link to="/doctor-login" className="book-btn">
                  Login
                </Link>
              </li>
}
  { isAuthenticated &&
 <DashboardTabs style={{ paddingTop: '1rem' }} name={''} />
  }



 { isAuthenticated && 
               <li className="ms-lg-4 mt-3 mt-lg-0">
                <button onClick={()=>{ handleLogout()}}  className="btn  btn-link " style={{ backgroundColor: 'transparent', color: '#0f4c81', textDecoration: 'none', border: 'none', padding: '0', cursor: 'pointer' }}>
                  Logout
                </button>
              </li>
}

            </ul>
          </div>

          }

          
        </div>
      </nav>
  );
}

export default AppHeader;
